import { createReducer } from '@reduxjs/toolkit';

import postCoOrder from '../../../thunks/coilovers/orders/postCoOrder';
import { clearPostCoOrder } from '../../../actions/coilovers/orders/postCoOrder';

const initialState = {
  loading: false,
  error: null,
  data: {},
};

const postCoOrderReducer = createReducer(initialState, {
  [postCoOrder.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [postCoOrder.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [postCoOrder.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearPostCoOrder]: () => initialState
});

export default postCoOrderReducer;
